import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SocService {

  uri = environment.baseUrl + 'soc';

  constructor(private http: HttpClient) { }

  // Get all contact
  getSocs() {
    return this.http.get(`${this.uri}/`);
  }

  // Get selected contact
  getSoc(id) {
    return this.http.get(`${this.uri}/soc/${id}`);
  }

  // Add image
  addSoc(post) {
    return this.http.post(`${this.uri}/add`, post);
  }

  // Edite selected image
  editSoc(id, post: any) {
    return this.http.put(`${this.uri}/edite/${id}`, post);
  }

  // Delete selected image
  deleteSoc(id) {
    return this.http.get(`${this.uri}/delete/${id}`);
  }
}
